module.exports = __webpack_public_path__ + "img/system16-mini.6242bcd8.png";